import { Input } from '@/components/ui/input';

class EditableString {
  constructor(value) {
    this._chars = [...value]; // Store characters in an array

    return new Proxy(this, {
      get(target, prop) {
        if (!isNaN(prop)) return target._chars[prop]; // Allow indexing
        if (prop === 'length') return target._chars.length; // Allow length check
        if (prop === 'includes') return (...args) => target._chars.join('').includes(...args);
        if (prop === 'indexOf') return (...args) => target._chars.join('').indexOf(...args);
        if (prop === 'toString') return () => target._chars.join('');
        return target[prop];
      },
      set(target, prop, value) {
        if (!isNaN(prop) && prop >= 0 && prop < target._chars.length) {
          target._chars[prop] = value; // Modify character
          return true;
        }
        return false;
      }
    });
  }
}

export default function NumberInput(props) {
  const { onChange, type: _1, autoComplete: _2, ...inputProps } = props;

  return (
    <Input
      type='text'
      autoComplete='off'
      {...inputProps}
      onChange={event => {
        const { target } = event;
        let { value } = target;

        let sanitizedValue = new EditableString(
          value
            .replace(/[^\d.]/g, '') // Remove non-numeric and non-dot characters
            .replace(/^0+(?=\d)/, '') // Remove leading zeros
        );

        // Remove extra dots after the first one
        if (sanitizedValue.includes('.')) {
          const firstDotIndex = sanitizedValue.indexOf('.');
          let newChars = sanitizedValue.toString().split('');
          newChars = newChars.filter((char, i) => char !== '.' || i === firstDotIndex);
          sanitizedValue = new EditableString(newChars.join(''));
        }

        // Restrict to 9 digits after the decimal point
        if (sanitizedValue.includes('.')) {
          const [beforeDot, afterDot] = sanitizedValue.toString().split('.');
          sanitizedValue = new EditableString(`${beforeDot}.${afterDot.slice(0, 9)}`);
        }

        // Prevent values exceeding Number.MAX_SAFE_INTEGER
        if (Number(sanitizedValue.toString()) > Number.MAX_SAFE_INTEGER) return;

        if (onChange) onChange(sanitizedValue.toString() || '0');
      }}
    />
  );
}
